<template>
  <div class="tags-filter text-dark" :class="{'flex_columns': columns}">
    <div class="tags_filter__selected">
      <div class="icon-filter"></div>
      <div class="tags_filter__selected">
        <ul>
          <li v-for="tag in selectedTags">
            <tag
              :tag="tag"
              @remove="removeTag">
            </tag>
          </li>
        </ul>
      </div>
    </div>
    <button v-if="!active" class="btn-trans tags-filter__header__s-btn" @click="active = true">+
      {{ searchText.length > 1 ? searchText : $t('vue2.tagging.search_tag') }}
    </button>
    <div class="tags-filter-wrapper" v-else v-on-clickaway="hideActive">
      <div class="tags-filter__header">
        <span class="icon-search5"></span>
        <input type="text"
               v-focus
               v-model="tagText"
               class="tags-filter__header__search"
               :class="{'show': showDropdown}">
      </div>
      <div class="tags_filter__tags" :class="{'show': showDropdown}">
        <h4 v-if="!isShowNoTagsText && (tags.length === 0)">{{ $t('vue2.dselect.no_matching_results') }}</h4>
        <h4 v-show="tags.length < 1 && isShowNoTagsText">{{ $t('vue2.tagging.you_have_created_zero_tags') }}
          <a :href="'/schools/' + schoolid  + '/groups/#/'">{{ $t('vue2.tagging.create_tags') }}</a>
        </h4>
        <h4 v-show="filteredTags.length < 1 && tags.length > 0">0 {{ $t('vue2.tagging.with') }} "{{tagText}}"</h4>
        <ul v-show="filteredTags.length > 0">
          <li v-for="tag in notSelectedTags" @click="setTag(tag)">
            <span class="icon-price-tag2"></span> {{tag}} <span v-if="showHowMany">({{howManyWithTag(tag)}})</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import tag from './Tag'
  import {mixin as clickaway} from 'vue-clickaway'

  const userLocale = window.USER && window.USER.language ? window.USER.language : 'da'

  export default {
    mixins: [clickaway],
    components: {tag},
    props: {
      tags: {
        type: Array,
        default: () => []
      },
      searchText: {
        default: ''
      },
      users: {
        type: Array,
        default: () => []
      },
      selectedTags: {
        type: Array,
        default: () => []
      },
      columns: {
        type: Boolean,
        default: false
      },
      showHowMany: {
        type: Boolean,
        default: true
      },
      isShowNoTagsText: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        active: false,
        showDropdown: false,
        showInput: false,
        tagText: ''
      }
    },
    directives: {
      focus: {
        // directive definition
        inserted: function (el) {
          el.focus()
        }
      }
    },
    watch: {
      active () {
        if (this.active) {
          setTimeout(() => {
            this.showDropdown = true
          }, 0)
        } else {
          this.showDropdown = false
        }
      }
    },
    computed: {
      sortedTags () {
        return this.tags.sort((a, b) => a.localeCompare(b, userLocale, {
          numeric: true,
          sensitivity: 'base'
        }))
      },
      filteredTags () {
        return this.sortedTags.filter(tag => {
          return tag !== '' ? tag.match(new RegExp(this.tagText, 'i')) : ''
        })
      },
      personsWithTags () {
        if (!this.showHowMany) {
          return 0
        }
        return this.users.filter(user => user.tags && user.tags.length > 0)
      },
      notSelectedTags () {
        return this.filteredTags.filter(tag => {
          return this.selectedTags.indexOf(tag) < 0
        })
      },
      schoolid () {
        return window.SCHOOL.id
      }
    },
    methods: {
      hideActive () {
        this.tagText = ''
        this.active = false
      },
      setTag (tag) {
        this.$emit('set', tag)
        this.hideActive()
      },
      howManyWithTag (tag) {
        let arr = this.personsWithTags.filter(user => {
          return user.tags.indexOf(tag) > -1
        })
        return arr.length
      },
      removeTag (tag) {
        this.$emit('remove', tag)
      }
    }
  }
</script>

<style scoped>
  @import '../../assets/css/variables.css';

  .tags-filter {
    position: relative;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .tags-filter.flex_columns {
    flex-direction: column;
  }

  .tags_filter__selected {
    display: flex;
    align-items: center;
    margin-right: 0;
  }

  .tags_filter__selected > .icon-filter {
    margin-right: 0.5rem
  }

  .tags_filter__selected ul {
    display: flex;
    flex-wrap: wrap;
    max-width: 100%;
    gap: 5px;
  }

  .flex_columns .tags_filter__selected ul {
    flex-direction: column;
  }

  .tags-filter-wrapper {
    position: relative;
  }

  .tags-filter__header {
    position: relative;
    display: flex;
  }

  .tags-filter__header__s-btn {
    height: 34px;
    margin-left: 5px;
  }

  .tags-filter__header > span {
    position: absolute;
    left: 10px;
    top: 10px;
    color: #888;
  }

  .tags-filter__header__search {
    padding: 8px 16px 8px 36px;
    width: 100px;
    transition: width 0.25s;
    border-radius: 4px 4px 0 0;
  }

  .tags-filter__header__search.show {
    width: 180px;
  }

  .tags_filter__tags {
    position: absolute;
    z-index: 10000;
    background-color: #ffffff;
    padding: 10px 0;
    top: 100%;
    left: 0;
    max-height: 50vh;
    overflow-y: auto;
    width: 100px;
    border-radius: 0 0 4px 4px;
    opacity: 0;
    transform: scaleY(0);
    transition: all .1s ease;
    box-shadow: 0 4px 14px 0 rgba(0, 0, 0, .2), 0 0 0 1px rgba(0, 0, 0, .05);
  }

  .tags_filter__tags.show {
    transition: all .1s ease;
    transform: scaleY(1);
    opacity: 1;
    transform-origin: top;
    width: 180px;
  }

  .tags_filter__tags h4 {
    padding: 5px 15px;
    color: #888888;
  }

  .tags_filter__tags li {
    padding: 5px 15px;
    cursor: pointer;
  }

  .tags_filter__tags li:hover {
    background-color: var(--blue);
    color: white;
  }

  .tags_filter__tags li span {
    padding-right: 7px;
  }
</style>



// WEBPACK FOOTER //
// TaggingFilter.vue?4b0fe36a